import { Card } from "../../models/card";
import { cards } from "../../state";
import { PurpleGolem } from "../upgrades/purpleGolem";
export class MakePurpleGolem extends Card {
}
MakePurpleGolem.displayName = "Purple Golem";
MakePurpleGolem.artUrl = "./assets/cards/purplegolem.jpg";
MakePurpleGolem.effect = {
    callback: () => {
        cards.push(new PurpleGolem({ x: 150, y: 240 }));
    },
    description: "Craft a Purple Golem. This one is a little more enthusiastic.",
    needsFeedback: true,
};
MakePurpleGolem.destroysOnPlay = true;
